// extracted by mini-css-extract-plugin
export default {"appBar":"Appbar_appBar__+7m5k"};